import { handleExpiredTokens } from 'api/apiReqSagaCreator/httpRequest';
import { PrintRenderScenarioWithHypermedia } from 'api/endpoints/printRender';
import { OdataURLBuilder } from 'api/types/OdataURLBuilder';

import BaseRepo from '../../BaseRepo';
import { ApiResponseAsync, translateAxiosErrorToApiError } from '../../models';
import { IPrintRenderLogRepo, PrintRenderLog } from './IPrintRenderRepo';

export class PrintRenderLogsRepo
  extends BaseRepo
  implements IPrintRenderLogRepo
{
  getLogs = (
    request: OdataURLBuilder
  ): ApiResponseAsync<DataWithTotal<PrintRenderLog>> =>
    handleExpiredTokens(() =>
      this.client.get<DataWithTotal<PrintRenderLog>>(request.toString())
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);

  getScenarios = (
    processId: string
  ): ApiResponseAsync<DataWithTotal<PrintRenderScenarioWithHypermedia>> =>
    handleExpiredTokens(() =>
      this.client.get<DataWithTotal<PrintRenderScenarioWithHypermedia>>(
        `/processes/${processId}/print-render/scenarios`
      )
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
}
